module.exports = __webpack_public_path__ + "static/media/icon8.5075b127.svg";